<template>
  <div class="iframe-megjelenito-wrapper">
    <iframe
      :src="iframeUrl"
      frameborder="0"
      class="iframe-megjelenito"
    ></iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'IframeMegjelenito',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
    iframeUrl() {
      return this.$route.query.url;
    },
  },
  watch: {},
  components: {},
};
</script>
